// About 페이지 영어 번역
export default {
  intro: {
    title: 'Welcome',
    churchName: 'Seongdong Jungang Church',
    description1: 'We sincerely welcome all visitors to Seongdong Jungang Church.',
    description2: 'Our Seongdong Jungang Church is a church that holds Jesus Christ as our dream and hope.',
    description3: 'We are a church that places absolute authority on God\'s Word and takes it as the standard of faith.',
    description4: 'We are a church where God accomplishes greater things through us. We invite you to this beautiful community.',
    missionTitle: 'Church Vision',
    missionText: 'Our church is a God-centered church that forms a family community, becomes mature Christians, worships God rightly, and prepares to welcome the Lord who will come again.'
  },
  leadership: {
    title: 'Our',
    titleHighlight: 'Leaders',
    description: 'Meet the pastors and elders who serve Seongdong Jungang Church.',
    pastorSection: 'Pastors',
    elderSection: 'Elders',
    activeElder: 'Active Elder',
    emeritusElder: 'Emeritus Elder'
  },
  staff: {
    title: 'Associate',
    titleHighlight: 'Pastors',
    description: 'Associate pastors who serve together in ministry.',
    note: 'Associate pastor information is being prepared.'
  },
  location: {
    title: 'Visit',
    titleHighlight: 'Us',
    description: 'Please visit Seongdong Jungang Church.',
    addressTitle: 'Address',
    parkingTitle: 'Parking',
    parkingDescription: 'Parking is available on the 1st floor and basement.',
    transportTitle: 'Directions',
    subwayLabel: 'Subway:',
    busLabel: 'Bus:'
  },
  schedule: {
    title: 'Worship',
    titleHighlight: 'Schedule',
    description: 'Worship service schedule at Seongdong Jungang Church.',
    tableService: 'Service',
    tableTime: 'Time',
    tableLocation: 'Location',
    note: 'Worship times are subject to change. Please contact the church office for details.'
  }
};
